import React from "react";
import MarketResearch from "./components/MarketResearch";

function App() {
  return (
    <div>
      <MarketResearch />
    </div>
  );
}

export default App;
